<div class="TotemHomeBottom {{ isDocked ? 'TotemHomeBottom--Dock' : '' }}" #containerElement>
    <div class="TotemHomeBottom-Inner">
        <div>
            @if (canPrint()) {
                <div class="TotemHomeBottom-Buttons">
                    <div>
                        <button type="button" class="btn btn-primary" (click)="doPrint()" [attr.aria-label]="'totem-a11y.print' | locTranslate">
                            <i class="fa-regular fa-2x fa-print" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            }
        </div>

        <div>
            @if (isLoading) {
                <div class="py-2 px-3">
                    <app-pg-loading></app-pg-loading>
                </div>
            }

            @if (!isLoading) {
                @if (currentContent != null) {
                    <div class="TotemHomeBottom-Content border mb-2" role="region" [attr.aria-label]="currentContent">
                        @if (currentContent == 'search') {
                            <div class="bg-white">
                                <div class="TotemHomeBottom-Content-Search">
                                    <div class="p-2 TotemHomeBottom-Content-Search-Main">
                                        @if(isSearching) {
                                            <app-pg-loading></app-pg-loading>
                                        }
                                        @else if(searchResults == null) {
                                            <div class="TotemHomeBottom-Content-Search-Main-Title">                                                
                                                <h4 class="m-0 text-muted" id="totem-search-title">{{ 'totem-home-bottom.search-title' | locTranslate }}</h4>
                                            </div>
                                        }
                                        @else {
                                            @if(searchResults.length == 0) {
                                                <div role="status">{{ 'totem-home-bottom.search-no-results' | locTranslate }}</div>
                                            }
                                            @else {
                                                @for(product of searchResults; track product) {
                                                    <div class="pb-2">
                                                        <app-ef-product-card [productData]="product" (showProduct)="goToProduct(product)"></app-ef-product-card>
                                                    </div>
                                                }
                                            }
                                        }
                                    </div>
                                    <div class="px-2 pb-2 TotemHomeBottom-Content-Search-Input">
                                        <label class="visually-hidden" for="totem-home-search-input">{{ 'totem-a11y.search-label' | locTranslate }}</label>
                                        <input id="totem-home-search-input" class="form-control" [(ngModel)]="searchValue" (ngModelChange)="onSearchValueChange()" [attr.placeholder]="'totem-home-bottom.search-placeholder' | locTranslate" [attr.aria-labelledby]="searchResults == null ? 'totem-search-title' : null">
                                    </div>
                                </div>
                            </div>
                        }
                        @if (currentContent == 'chat') {
                            <app-pg-customer-care [unathorizedName]="chatUnathorizedName" [chatBooking]="chatBooking" [realmId]="realmId" [customerCareChannel]="customerCareChannel" [hasCustomerCareBooking]="true" (customerCareBookingRequest)="goToCustomerCareBooking()"></app-pg-customer-care>
                        }
                        @if (currentContent == 'user') {
                            <div class="bg-white">
                                <app-pg-login-handler [canDismiss]="true" (loginDismissed)="onLoginDismissed()"></app-pg-login-handler>
                                @if (isLoggedIn()) {
                                    <div class="TotemHomeBottom-Content-User">
                                        <div class="text-end">
                                            <button type="button" class="btn btn-link" (click)="logout()">
                                                <span>Logout</span>
                                                <i class="fa-regular fa-right-from-bracket" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                        <div class="TotemHomeBottom-Content-User-Main px-3 py-2 border-top">
                                            <app-pg-notification-list [markAsReadOnDestroy]="true"></app-pg-notification-list>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        @if (currentContent == 'debug') {
                            <!-- TODO: spostarci dentro anche selettore fasi viaggio -->
                            <div class="bg-white p-2">
                                <h5>Variabili</h5>
                                @if(homeVariables != null) {
                                    @for(item of homeVariables | keyvalue : null; track item) {
                                        @for(prop of item.value | keyvalue : null; track prop) {
                                            <div>
                                                <label>
                                                    <input type="checkbox" [(ngModel)]="item.value[prop.key]">
                                                    <span class="ms-2">{{item.key}}.{{prop.key}}</span>
                                                </label>
                                            </div>
                                        }
                                    }
                                }
                            </div>
                        }
                    </div>
                }
                <div class="TotemHomeBottom-Buttons">
                    @if (isDebugEnabled()) {
                        <div>
                            <button type="button" class="btn btn-dark rounded-circle shadow-sm text-white" (click)="toggleCurrentContent('debug')" [attr.aria-label]="'totem-a11y.debug' | locTranslate" [attr.aria-expanded]="currentContent == 'debug'">
                                <i class="fa-regular fa-2x fa-gears" aria-hidden="true"></i>
                            </button>
                        </div>
                    }
                    @if(productsData) {
                        <div>
                            <button type="button" class="btn btn-info rounded-circle shadow-sm text-white" (click)="toggleCurrentContent('search')" [attr.aria-label]="'totem-a11y.search' | locTranslate" [attr.aria-expanded]="currentContent == 'search'">
                                <i class="fa-regular fa-2x fa-search" aria-hidden="true"></i>
                            </button>
                        </div>
                    }
                    @if (isChatEnabled() && !whatsappChat) {
                        <div>
                            <button type="button" class="btn btn-success rounded-circle shadow-sm" (click)="toggleCurrentContent('chat')" [attr.aria-label]="'totem-a11y.chat' | locTranslate" [attr.aria-expanded]="currentContent == 'chat'">
                                <i class="fa-regular fa-2x fa-comment-dots" aria-hidden="true"></i>
                            </button>
                        </div>
                    }
                    @if (whatsappChat) {
                        <div>
                            <button type="button" class="btn btn-success rounded-circle shadow-sm" (click)="goToWhatsappChat()" [attr.aria-label]="'totem-a11y.whatsapp' | locTranslate">
                                <i class="fa-brands fa-2x fa-whatsapp" aria-hidden="true"></i>
                            </button>
                        </div>
                    }
                    @if (appMode == 'web') {
                        <div>
                            <button type="button" class="btn btn-primary rounded-circle shadow-sm" (click)="toggleCurrentContent('user')" [attr.aria-label]="'totem-a11y.user' | locTranslate" [attr.aria-expanded]="currentContent == 'user'">
                                <i class="fa-regular fa-2x {{ isLoggedIn() ? 'fa-user' : 'fa-right-to-bracket' }}" aria-hidden="true"></i>
                            </button>
                            @if (getUnreadNotificationsCount(); as count) {
                                <span class="badge bg-danger rounded-circle" aria-hidden="true">{{count}}</span>
                            }
                        </div>

                        @if (canInstall()) {
                            <div>
                                <button type="button" class="btn btn-warning rounded-circle shadow-sm text-white" (click)="doInstall()" [attr.aria-label]="'totem-a11y.install' | locTranslate">
                                    <i class="fa-regular fa-2x fa-desktop-arrow-down" aria-hidden="true"></i>
                                </button>
                            </div>
                        }
                    }
                </div>
            }
        </div>
    </div>
</div>
